import React, {useContext} from 'react'
import {Paging} from '@elastic/react-search-ui'
import {useTranslation} from 'react-i18next'
import {AppContext} from '../../../context/context'
import {ScreenReaderOnly} from '../../../theme/visibility'

import './pagination-styles.scss'

const Pagination = () => {
  const {t} = useTranslation('common')
  const {state} = useContext(AppContext)

  const scrollToTop = (e, currentPage) => {
    e.preventDefault()

    //SET STATE
    state.currentPagination = currentPage

    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    })
  }

  return (
    <nav aria-label="pagination">
      <Paging
        itemRender={(current, type) => {
          // Only show the first 5 pages (top 100 results) for elaws
          if (state.filter === 'elaws' && current > 5) return null

          if (type === 'jump-prev' || type === 'jump-next') {
            return <span aria-hidden="true">&#8230;</span>
          }

          if (type === 'prev') {
            return (
              <a
                href="#navigate-previous"
                onClick={e => scrollToTop(e, current)}
                aria-label={t('pagination.aria.goToPrevious')}
                data-testing="pagination-previous"
              >
                <span aria-hidden="true">‹</span> {t('pagination.previous')}{' '}
                <ScreenReaderOnly>
                  {t('pagination.aria.previousPage')}
                </ScreenReaderOnly>
              </a>
            )
          }

          if (type === 'next') {
            return (
              <a
                href="#navigate-next"
                onClick={e => scrollToTop(e, current)}
                aria-label={t('pagination.aria.goToNext')}
                data-testing="pagination-next"
              >
                {t('pagination.next')} <span aria-hidden="true">›</span>
                <ScreenReaderOnly>
                  {t('pagination.aria.nextPage')}
                </ScreenReaderOnly>
              </a>
            )
          }

          return (
            <a
              href="#navigate-page"
              onClick={e => scrollToTop(e, current)}
              aria-label={`${t('pagination.aria.goToPage')} ${current}`}
            >
              <ScreenReaderOnly>Page</ScreenReaderOnly>
              {current}
            </a>
          )
        }}
        hideOnSinglePage={true}
      />
    </nav>
  )
}

export default Pagination
